const Tbox = () => import('@/pages/Tbox')
const createTbox = () => import('@/pages/Tbox/createTbox')
const mapDetail = () => import('@/pages/Tbox/mapDetail')
export default [{
  path: '/createTbox',
  name: 'createTbox',
  component: createTbox,
  meta: {}
},
{
  path: '/Tbox',
  name: 'Tbox',
  component: Tbox,
  meta: {
    storeKey: 'trs.tbox.index'
  }
},
{
  path: '/mapDetail',
  name: 'mapDetail',
  component: mapDetail,
  meta: {}
}
]



// WEBPACK FOOTER //
// ./src/router/Tbox/index.js